module.exports = __webpack_public_path__ + "static/media/RighttoCorrectForm.b8c8ff36.pdf";